import xiaohongshu from '@/static/image/platform/1.png'
import douyin from '@/static/image/platform/dy.png'
import face from '@/static/image/platform/3.png'
import Instagram from '@/static/image/platform/Instagram.png'
import Tiktok from '@/static/image/platform/Tiktok.png'
import Youtube from '@/static/image/platform/Youtube.png'
const imgArr = [{
  name: '小红书',
  img: xiaohongshu
},
{
  name: '抖音',
  img: douyin
},
{
  name: 'facebook',
  img: face
},
{
  name: 'Instagram',
  img: Instagram
},
{
  name: 'Tiktok',
  img: Tiktok
},
{
  name: 'Youtube',
  img: Youtube
}]
export default function (str:string) {
  console.log(str)
   return imgArr.find(({ name }) => name == str)?.img
}